import { Col, Input, InputNumber, Row } from 'antd';
import React, { useState } from 'react';
import { AntTooltip } from '../common/AntTooltip';

const AbhaIncentiveCalculator: React.FC = () => {
    const [monthlyOpd, setMonthlyOpd] = useState(30);

    const incentiveValue = (monthlyOpd * 5 - 100) * 20;

    return (
        <div className="w-full h-full overflow-auto hide-scrollbar justify-between border border-darwin-neutral_new-200 rounded-8 flex flex-col">
            <div className="p-16 flex gap-16 flex-col items-center">
                <div className="flex gap-2 flex-col items-center justify-center">
                    <span className="text-darwin-green-primary text-20 font-700">
                        Your incentive projection
                    </span>
                    <span className="text-darwin-neutral_new-1000 text-18 font-700">
                        This month, you can earn up to
                    </span>
                </div>
                <div className="flex flex-col rounded-8 justify-between items-center px-16 py-8 abha-linked-inner-more">
                    <span className="text-24 font-700">
                        ₹ {incentiveValue <= 0 ? 0 : incentiveValue.toLocaleString('en-IN')}
                    </span>
                    <span className="text-13 font-400">((A* B) - C) * D</span>
                </div>
                <Row gutter={[12, 12]} className="w-full">
                    <Col span={12}>
                        <div className="py-8 h-full justify-between px-16 gap-4 flex flex-col items-start rounded-4 bg-darwin-neutral_new-50">
                            <p className="text-13 font-700">Monthly OPD (A)</p>
                            <InputNumber
                                type={'number'}
                                min={0}
                                value={monthlyOpd}
                                onChange={(e) => setMonthlyOpd(e ?? 0)}
                                className="rounded-4 w-full"
                            />
                        </div>
                    </Col>

                    <Col span={12}>
                        <AntTooltip
                            placement="right"
                            content="Under DHIS you can link max 5 records /patient/month"
                        >
                            <div className="py-8 px-16 h-full justify-between gap-4 flex flex-col items-start rounded-4 bg-darwin-neutral_new-50">
                                <p className="text-13 font-700">Records Linked (B)*</p>
                                <Input
                                    type="text"
                                    className="pointer-events-none rounded-4"
                                    value="05"
                                />
                            </div>
                        </AntTooltip>
                    </Col>
                    <Col span={12}>
                        <div className="py-8 px-16 gap-4 flex flex-col items-start rounded-4 bg-darwin-neutral_new-50">
                            <p className="text-13 font-700">DHIS Cutoff (C): 100</p>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className="py-8 px-16 gap-4 flex flex-col items-start rounded-4 bg-darwin-neutral_new-50">
                            <p className="text-13 font-700">Incentive (D): Rs. 20</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default AbhaIncentiveCalculator;
